export default {
  companyRoadmapsMetadata: {
    titles: {
      list: 'Реестр ИПР',
      tasksStat: 'Статистика задач плана',
    },
    stat: {
      total: 'Всего ИПР',
      overdue_total: 'С просроченными задачами',
      avg_progress: 'Средний прогресс',
      draft_total: 'Черновик',
      on_approval_total: 'На согласовании',
      revision_total: 'На доработке',
      in_progress_total: 'В работе',
      on_acceptance_total: 'На подтверждении',
      done_total: 'Завершены',
      canceled_total: 'Отменены',
    },
    filters: {
      teamGroup: 'Подразделение',
      goalType: 'Тип цели развития',
      reason: 'Основание создания',
      source: 'Источник ИПР',
      skillType: 'Тип навыков',
      status: 'Статус ИПР',
      deadline: 'Период / Дедлайн',
      hasOverdue: 'Наличие просроченных задач',
    },
    tableHeaders: {
      employee: 'Сотрудник',
      reason: 'Основание создания',
      goalType: 'Тип цели развития',
      deadline: 'Дедлайн',
      status: 'Статус ИПР',
      mentor: 'Наставник',
      progress: 'Прогресс',
      source: 'Источник ИПР',
      actions: 'Действия',
    },
    taskStatItems: {
      total: 'Всего',
      newCount: 'Новые',
      inProgressCount: 'В работе',
      doneCount: 'Выполнено',
      overdueCount: 'Просрочено',
    },
    stubs: {
      noPlans:
        'Планов развития пока нет<br/>Создайте первый ИПР — для одного сотрудника или для группы',
    },
    // messages
    successMessages: {
      cancel: 'План развития отменён',
      delete: 'Черновик плана удалён',
    },
    errorMessages: {
      load: 'Не удалось загрузить планы развития',
      tasksStat: 'Не удалось загрузить статистику задач',
      cancel: 'Не удалось отменить план развития',
      delete: 'Не удалось удалить черновик плана',
    },
    // confirm dialogs
    confirmCancelRoadmap: {
      title: 'Отменить ИПР?',
      text: 'План перейдёт в статус «Отменён». Обратного перехода из статуса «Отменён» нет — возобновить план нельзя, нужно создавать новый.',
      button: 'Да, отменить',
      buttonCancel: 'Не отменять',
    },
    confirmDeleteRoadmap: {
      title: 'Удалить черновик ИПР?',
      text: 'Черновик будет удалён без возможности восстановления.',
    },
  },
};
